<template>
  <div class="row" :class="classes">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Row',
  props: {
    alignItems: {
      type: String,
      default: undefined
    },
    justifyContent: {
      type: String,
      default: undefined
    },
    fullHeight: {
      type: [Boolean, String],
      default: false
    }
  },
  computed: {
    classes () {
      return {
        [`align-items-${this.alignItems}`]: this.alignItems,
        [`justify-content-${this.justifyContent}`]: this.justifyContent,
        'full-height': this.fullHeight && this.fullHeight !== 'force',
        'full-height-force': this.fullHeight && this.fullHeight === 'force'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../scss/boilerplate';

.row {
  @include make-row()
}

.align-items {
  &-center {
    align-items: center;
  }
}
.justify-content {
  &-center {
    justify-content: center;
  }
}
.full-height {
  min-height: 100vh;

  &-force {
    height: 100vh;
  }
}
</style>


// WEBPACK FOOTER //
// Row.vue?492d00ea